export default "__VITE_ASSET__dpoGywXZ__"